<po-page-default p-title="Cadastro de Usuários" [p-breadcrumb]="breadcrumb">
  <p class="page-subtitle">Consulte os usuários cadastrados no sistema.</p>

  <div class="po-row actions-row">
    <div class="po-lg-8">
      <po-button
        class="po-mr-2"
        p-label="Novo Usuário"
        p-kind="primary"
        icon="po-icon-plus"
        (p-click)="openNewUserModal()"
      ></po-button>
      <po-button p-label="Atualizar" p-kind="secondary" (p-click)="refreshData()"></po-button>
    </div>
    <po-input
      class="po-lg-4 search-input"
      p-placeholder="Buscar por nome ou e-mail..."
      [(ngModel)]="search"
      (ngModelChange)="applySearch()"
    >
    </po-input>
  </div>

  <p class="po-font-subtitle">Verifique todos os usuários cadastrados no sistema.</p>
  <po-divider></po-divider>

  <div class="users-list-wrap">
    <po-loading-overlay [hidden]="deletingUserEmail === null"></po-loading-overlay>

    <!-- Loading state -->
    <div class="users-loading" *ngIf="loading && filteredUsers.length === 0">
      <po-loading-overlay [p-screen-lock]="false"></po-loading-overlay>
      <p class="users-loading-text">Carregando usuários…</p>
    </div>

    <!-- Empty state -->
    <div class="users-empty" *ngIf="!loading && filteredUsers.length === 0">
      <span class="po-icon po-icon-user po-font-title users-empty-icon"></span>
      <p>Nenhum usuário encontrado.</p>
    </div>

    <div class="users-list" *ngIf="filteredUsers.length > 0">
      <div class="users-header">
        <span>Nome</span>
        <span>E-mail</span>
        <span>Ativo</span>
        <span>Ações</span>
      </div>

      <div class="users-row" *ngFor="let row of filteredUsers">
        <span>{{ row.nome }}</span>
        <span>{{ row.email }}</span>
        <span>{{ row.ativada }}</span>
        <div class="user-actions">
          <button class="icon-action" type="button" title="Alterar role" (click)="openRolesModal(row)">
            <span class="an an-note-pencil"></span>
          </button>
          <button
            class="icon-action danger"
            type="button"
            title="Remover usuário"
            [disabled]="deletingUserEmail !== null"
            (click)="removeUser(row)"
          >
            <span class="an an-trash"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</po-page-default>

<po-modal #newUserModal p-title="Novo Usuário" p-size="md">
  <div class="po-row">
    <po-input class="po-lg-12" p-label="Nome Completo" [(ngModel)]="newUser.nomeCompleto" [disabled]="creatingUser"></po-input>
    <po-email class="po-lg-12" p-label="E-mail" [(ngModel)]="newUser.email" [disabled]="creatingUser"></po-email>
  </div>
  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="tertiary" [p-disabled]="creatingUser" (p-click)="newUserModal.close()"></po-button>
    <po-button p-label="Criar Usuário" [p-loading]="creatingUser" [p-disabled]="creatingUser" (p-click)="createUser()"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #rolesModal p-title="Associar/Remover Roles" p-size="lg">
  <p class="po-font-text">Usuário: <b>{{ selectedUser?.nome }}</b> ({{ selectedUser?.email }})</p>
  <p class="po-font-text">Exibindo apenas as roles que o usuário já possui.</p>
  <div class="roles-toolbar" *ngIf="!rolesLoading">
    <span></span>
    <div class="roles-toolbar-actions">
      <po-button p-label="Atribuir novas roles" p-kind="primary" (p-click)="openAssignRolesModal()"></po-button>
    </div>
  </div>
  <div class="roles-list" *ngIf="!rolesLoading && roles.length > 0">
    <div class="roles-header">
      <span>Role</span>
      <span>Ações</span>
    </div>
    <div class="roles-row" *ngFor="let row of roles">
      <span class="role-name">{{ row.name }}</span>
      <div class="role-actions">
        <po-button p-size="small" p-kind="danger" p-label="Remover" p-icon="po-icon-delete" (p-click)="removeRole(row)"></po-button>
      </div>
    </div>
  </div>
  <div class="roles-empty" *ngIf="!rolesLoading && roles.length === 0">Usuário não possui permissões.</div>
  <div class="roles-empty" *ngIf="rolesLoading">Carregando permissões...</div>
  <po-modal-footer>
    <po-button p-label="Fechar" p-kind="tertiary" (p-click)="rolesModal.close()"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #assignRolesModal p-title="Atribuir novas roles" p-size="lg">
  <p class="po-font-text">Usuário: <b>{{ selectedUser?.nome }}</b> ({{ selectedUser?.email }})</p>
  <p class="po-font-text">Roles disponíveis para adicionar (que o usuário ainda não possui).</p>
  <div class="roles-list" *ngIf="!availableRolesLoading && availableRoles.length > 0">
    <div class="roles-header">
      <span>Role</span>
      <span>Ação</span>
    </div>
    <div class="roles-row" *ngFor="let row of availableRoles">
      <span class="role-name">{{ row.name }}</span>
      <div class="role-actions">
        <po-button p-size="small" p-label="Adicionar" p-icon="po-icon-plus" (p-click)="assignRole(row)"></po-button>
      </div>
    </div>
  </div>
  <div class="roles-empty" *ngIf="!availableRolesLoading && availableRoles.length === 0">Não há roles disponíveis para adicionar.</div>
  <div class="roles-empty" *ngIf="availableRolesLoading">Carregando roles disponíveis...</div>
  <po-modal-footer>
    <po-button p-label="Fechar" p-kind="tertiary" (p-click)="assignRolesModal.close()"></po-button>
  </po-modal-footer>
</po-modal>
